module.exports = __webpack_public_path__ + "summer/img/bg_my.e842aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/present/bg_my.png
// module id = kAsy
// module chunks = 39